<template>
  <div v-if="!loading" class="form-page">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
    />

    <div class="container">
      <div class="card">
        <div class="wrap-top-buttons">
          <div class="form-tabs">
            <div
              @click="tab = 'new'"
              :class="
                `common-button tab-item ${tab == 'new' ? 'selected' : ''}`
              "
            >
              {{ $t("form.tabs.submitResponse") }}
            </div>
          </div>
          <FlagButton :lang="localLanguage" @flagChange="handleFlagChange" />
        </div>
        <div class="card-body">
          <template v-if="error_load">
            <h4>
              <strong>{{ $t("messages.search_title") }}</strong>
            </h4>
            <p>{{ $t("messages.search_desc") }}</p>
          </template>
          <template v-else>
            <template v-if="respondSuccess">
              <h4>
                <strong>{{ $t("messages.sent_title") }}</strong>
              </h4>
              <p>{{ $t("messages.sent_desc") }}</p>
            </template>
            <template v-else-if="ableToView">
              <h1 class="text-certer company-name">
                {{ incident.company_name }}
              </h1>
              <div v-if="incident.logo" class="company-logo">
                <img
                  :src="incident.logo"
                  :alt="`Logo ${incident.company_name}`"
                />
              </div>

              <table style="width: 100%">
                <tbody>
                  <tr style="background-color: #e1e8ec">
                    <td style="width: 50%">
                      <span>
                        <strong>{{ $t("headers.protocol") }}:</strong>
                        {{ incident.protocol }}
                      </span>
                    </td>
                    <td>
                      <span>
                        <strong>{{ $t("headers.solicitation_date") }}:</strong>
                        {{ incident.created_at }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">
                      <p>
                        <strong>{{ $t("form.labels.message") }}:</strong>
                      </p>
                      <div class="format-text">
                        {{ incident.text }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                class="table"
                v-if="incident.files && incident.files.length"
              >
                <thead>
                  <tr>
                    <th>{{ $t("headers.file") }}</th>
                    <th>{{ $t("headers.actions") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="file in incident.files"
                    :key="file.file"
                    :title="file.title"
                  >
                    <td>
                      <div class="text-container">{{ file.title }}</div>
                    </td>
                    <td>
                      <button @click="downloadFile(file)">
                        Visualizar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <template v-if="incident.type == 'solicitation'">
                <div class="form-container">
                  <h3 class="my-0">{{ $t("form.labels.response") }}</h3>
                  <hr />
                  <div class="form-group">
                    <label for="input-message"
                      >{{ $t("form.labels.message") }} *</label
                    >
                    <textarea
                      id="input-message"
                      v-model="data.message"
                      :class="`input ${errors.message ? 'input-error' : ''}`"
                      rows="5"
                      :disabled="saving"
                    ></textarea>

                    <small
                      class="form-error"
                      v-if="$v.data.message.$error && !$v.data.message.required"
                    >
                      {{ $t("form.validations.message_required") }}
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="input-files"
                      >{{ $t("form.labels.files") }}
                    </label>
                    <input
                      type="file"
                      :disabled="saving"
                      @change="onFileChange"
                      class="input"
                      multiple
                    />
                    <small v-if="!$v.data.files.$error">
                      {{ $t("form.hint.start") }} <strong>Ctrl</strong>
                      {{ $t("form.hint.end") }}
                    </small>
                    <small
                      class="form-error"
                      v-if="$v.data.files.$error && !$v.data.files.max500mb"
                    >
                      {{ $t("form.validations.file_size_500mb") }}
                    </small>
                  </div>

                  <div class="form-group flex-container justify-end">
                    <button
                      :disabled="saving"
                      @click="postForm()"
                      class="btn common-button"
                      type="button"
                    >
                      <span>{{ $t("utils.send") }}</span>
                      <i
                        v-if="saving"
                        style="margin-left:4px"
                        class="fa fa-spin fa-spinner"
                      ></i>
                    </button>
                  </div>
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>
    </div>
    <BeFooter style="margin-top: 30px" background="#ffffff" />
  </div>
</template>

<script>
import FlagButton from "./FlagButton.vue";
import BeFooter from "./BeFooter.vue";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import appApi from "@/plugins/api";
export default {
  name: "PreviewCall",
  components: { FlagButton, BeFooter },

  props: {
    msg: String,
  },

  beforeCreate() {
    document.querySelector("body").classList.add("bkg-gray");
  },
  beforeDestroy() {
    document.querySelector("body").classList.remove("bkg-gray");
  },

  data() {
    return {
      localLanguage: "pt-BR",
      loading: false,
      ableToView: false,
      solicitationAvailable: false,
      holderOccupations: [],
      saving: false,
      respondSuccess: false,
      showForm: true,
      showError: false,
      uploaded_files: [],
      options: null,
      incident: {},
      error_load: false,
      tab: "new",
      errors: {},
      types: [],
      data: {
        name: "",
        text: "",
        message: "",
        files: [],
      },

      showStatus: false,
      showErrorQuery: false,
      protocol: "",
      errorsQuery: {},
      statusText: "",
      site_url: process.env.VUE_APP_SITE_URL,
    };
  },
  validations: {
    data: {
      message: { required },
      files: {
        max500mb: (files) => {
          if (files && files.length > 0) {
            let totalSize = 0;

            files.forEach((file) => {
              totalSize += file.size;
            });

            const sizeInMb = (totalSize / (1024 * 1024)).toFixed(2);

            if (sizeInMb > 500.0) {
              return false;
            }
          }

          return true;
        },
      },
    },
  },

  created() {
    // alert("OK");
    this.createForm();
  },

  methods: {
    checkSizes(files) {
      if (files.length > 0) {
        let totalSize = 0;

        files.forEach((file) => {
          totalSize += file.size;
        });

        const sizeInMb = (totalSize / (1024 * 1024)).toFixed(2);

        if (sizeInMb > 500.0) {
          return false;
        }
      }

      return true;
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.data.files = [];
      } else {
        this.data.files = [];
        for (let i = 0; i < e.target.files.length; i++) {
          this.data.files.push(e.target.files[i]);
        }
      }
    },
    downloadFile(file) {
      axios
        .get(process.env.VUE_APP_API_URL + "files/download/" + file.id, {})
        .then((res) => {
          window.open(res.data.url);
        })
        .catch((err) => {});
    },
    handleFlagChange(language) {
      this.localLanguage = language;
      this.createForm({ language });
    },
    handleHolderOccupationChange(value) {
      if (value !== "other") {
        this.data.holder_occupation_description = "";
      }
    },
    clearForm() {
      this.data = {};
      this.showForm = true;
      this.showError = false;
      this.errors = {};
    },
    createForm(params = { language: "pt-BR" }) {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "lgpd-titular/communication-history?token=" +
            this.$route.query.token,
          {}
        )
        .then((res) => {
          this.incident = res.data.data;
          this.ableToView = true;
          this.solicitationAvailable = true;
        })
        .catch(() => {
          this.error_load = true;
        });
    },

    postForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.saving = true;
        this.showError = false;
        this.errors = {};

        if (this.data.files.length > 0) {
          let totalUploaded = 0;

          for (const file of this.data.files) {
            appApi
              .directUploadFile(file, true, null, {
                token: this.$route.query.token,
              })
              .then((res) => {
                this.uploaded_files.push(res.data);
                totalUploaded++;
              })
              .finally(() => {
                if (totalUploaded == this.data.files.length) {
                  appApi
                    .postSaveCommunicationHistory({
                      token: this.$route.query.token,
                      message: this.data.message,
                      uploaded_files: this.uploaded_files,
                    })
                    .then(() => {
                      this.showForm = false;
                      this.respondSuccess = true;
                    })
                    .catch((error) => {
                      this.error_load = true;
                    })
                    .finally(() => {
                      this.saving = false;
                    });
                }
              });
          }
        } else {
          appApi
            .postSaveCommunicationHistory({
              token: this.$route.query.token,
              message: this.data.message,
              uploaded_files: [],
            })
            .then(() => {
              this.showForm = false;
              this.respondSuccess = true;
            })
            .catch((error) => {
              this.error_load = true;
            })
            .finally(() => {
              this.saving = false;
            });
        }
      }
    },

    getLogo() {
      return process.env.VUE_APP_LOGO;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

table td {
  border: none;
}
.table {
  border-collapse: collapse;
  border: 1px solid #2c3e50;
  width: 100%;
}

hr {
  border: unset;
  border-bottom: 1px solid #8f8f8f;
  margin-bottom: 1rem;
}

.form-container {
  margin-top: 1.5rem;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  background-color: rgba(0, 0, 0, 0.03);
}

.table th {
  text-align: left;
}

.table th,
td {
  padding: 8px;
  border: 1px solid #2c3e50;
}

.text-container {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
}

.table tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}

.table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

h3 {
  font-weight: normal !important;
}
.container {
  display: block;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.flex-container {
  display: flex;
  justify-content: space-between;
}

.justify-end {
  justify-content: end;
}

.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin-bottom: 1rem;
  background-color: #fff;
}

.my-0 {
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
}

.card-body {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 1.25rem;
}

.files-container {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 0.25rem 0.75rem;
  border-radius: 8px;
}

.files-container ul {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding-left: 1rem;
}

.mr-5 {
  margin-right: 1rem !important;
  margin-bottom: 1rem;
}

.form-page {
  display: block;
  position: relative;
  padding: 20px;
  height: 100vh;
  background-color: #e1e8ec;
  margin-bottom: 20px;
}
.form-page .form-group {
  margin-bottom: 20px;
  width: 100%;
  position: relative;
}
.form-page label {
  display: block;
  margin-bottom: 5px;
}

.form-page .input {
  border: 1px solid #2c3e50;
  background-color: #fff;
  min-width: 100%;
  max-width: 100%;
  border-radius: 4px;
  font-size: 15px;
  padding: 10px;
  position: relative;
  outline: none;
}

.form-page .input.input-error,
.form-page .input.input-error:focus {
  border: 1px solid #e74c3c;
}

.form-page .btn {
  background-color: #4caf50;
  border: 1px solid #ffffff;
  color: white;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  border-radius: 4px;
}
.form-page .btn:disabled {
  opacity: 0.4;
}
#logo {
  display: block;
  width: 80px;
}
.message-email {
  text-align: center;
  padding: 20px;
  height: 100vh;
}

.wrap-top-buttons {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid white;
  margin-bottom: 0.5rem;
}

.message-email .message-email-content {
  padding: 10px;
  border-radius: 5px;
  background-color: #fff;
}

.message-error {
  background-color: #e74c3c;
  color: #fff;
  padding: 20px;
  border-radius: 5px;
}

.form-tabs {
  border-bottom: 1px solid #fff;
}

.form-tabs .tab-item {
  display: inline-block;
  padding: 5px 10px;
  background-color: #e0dcdc;
  border: 1px solid #e0dcdc;
  cursor: pointer;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.form-tabs .tab-item.selected {
  border: 1px solid #fff;
  background-color: #fff;
}
.form-tabs .tab-item:hover {
  background-color: #fff;
  border: 1px solid #fff;
}
.status-info {
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 20px;
}
.be-logo a {
  margin: 0px;
  text-align: center;
  margin-top: 10px;
  background-color: #3498db;
  padding: 10px;
  border-radius: 5px;
  display: inline-block;
}
.be-logo img {
  margin: auto;
}
.format-text {
  white-space: pre-line;
  text-align: justify;
}
.text-certer {
  text-align: center;
}
.company-name {
  margin: 20px 0px;
}
.company-logo {
  text-align: center;
}
.company-logo img {
  margin: auto;
  max-width: 200px;
  max-height: 100px;
}

.form-error {
  color: #e74c3c;
}

.wrap-footer {
  display: flex;
  justify-content: center;
}
</style>
